
// export function calculateRequestCost(serviceType, companyPricing, services) {
//     let totalPrice = 0
//
//     console.log("calculateRequestCost services", services)
//     if (serviceType === "service") {
//         const tieredPricing = companyPricing.tieredPricing
//         const numberOfServices = services.length
//
//         const applicableTier = tieredPricing?.find(tier =>
//             numberOfServices >= tier.minServices &&
//             (tier.maxServices === undefined || (!tier.maxServices || numberOfServices <= tier.maxServices))
//         )
//         // Calculate the total price from the tiered pricing or the sum of service prices
//         totalPrice = applicableTier?.price ?? services.reduce((accumulator, service) => accumulator + (service.priceInCents ?? 0), 0)
//
//     } else if (serviceType === "shift" && services[0].timeSlot) {
//         totalPrice = services[0].timeSlot.priceInCents
//     }
//
//
//     // Calculate the company commission based on the companyCommissionRatePercent
//     const companyCommission = (totalPrice * companyPricing.companyCommissionRatePercent) / 100
//
//     // Employee earnings is the remaining amount after the commission
//     const employeeEarnings = totalPrice - companyCommission
//
//
//     return {
//         companyCommission: companyCommission,
//         currency: companyPricing.currency,
//         employeeEarnings: employeeEarnings,
//         totalCost: totalPrice
//     }
//
// }

export function calculateRequestCost(companyPricing, services, serviceType, employeeType) {
    let totalPrice = 0
    console.log("calculateRequestCost", services)
    if (serviceType === "service") {
        const tieredPricing = companyPricing.tieredPricing
        const numberOfServices = services.length

        const applicableTier = tieredPricing?.find(tier =>
            numberOfServices >= tier.minServices &&
            tier.employeeTypes.includes(employeeType) &&
            (tier.maxServices === undefined || (!tier.maxServices || numberOfServices <= tier.maxServices))
        )
        // Calculate the total price from the tiered pricing or the sum of service prices
        totalPrice = applicableTier?.price ?? services.reduce((accumulator, service) => accumulator + (service.priceInCents ?? 0), 0)

    } else if (serviceType === "shift") {
        totalPrice = services[0].timeSlot?.priceInCents ?? 0
    }


    // Calculate the company commission based on the companyCommissionRatePercent
    const companyCommission = (totalPrice * companyPricing.companyCommissionRatePercent) / 100

    // Employee earnings is the remaining amount after the commission
    const employeeEarnings = totalPrice - companyCommission


    return {
        companyCommission: companyCommission,
        currency: companyPricing.currency,
        employeeEarnings: employeeEarnings,
        totalCost: totalPrice
    }

}